import { AuthProvider } from "react-oidc-context";
import { BrowserRouter, useNavigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { oidcConfig } from "./config";
import { AccountProvider } from "./contexts/AccountContext";
import { useInfringementsWebSocket } from "./hooks/useInfringementsWebSocket";
import Routes from "./routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * Inner component that provides AuthProvider after BrowserRouter is mounted,
 * so onSigninCallback can use useNavigate to properly re-render the route tree.
 */
function AuthGateway() {
  const navigate = useNavigate();
  return (
    <AuthProvider {...oidcConfig} onSigninCallback={() => navigate("/home", { replace: true })}>
      <AccountProvider>
        <InfringementsWSBridge />
        <Routes />
      </AccountProvider>
    </AuthProvider>
  );
}

function InfringementsWSBridge() {
  useInfringementsWebSocket();
  return null;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthGateway />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
